<div class="info-container">
  <div class="info-title">{{ info.title }}</div>
  <div class="divider my-2"></div>
  <div class="info-description">
    <div>tel: {{ info.tel }}</div>
    <div>email: {{ info.email }}</div>
  </div>
</div>
